import { Text, Pressable, StyleSheet } from "react-native";
import { AntDesign } from "@expo/vector-icons";

const UploadPhotoBox = ({ pickImage, pickMedia, media = [], selectedImage }) => {
  const onPressHandler = pickMedia || pickImage;
  const selectedCount = Array.isArray(media)
    ? media.length
    : selectedImage
    ? 1
    : 0;

  return (
    <Pressable
      style={({ pressed }) => [styles.uploadPhotoBox, pressed ? styles.uploadPhotoBoxPressed : null]}
      onPress={onPressHandler}
      disabled={typeof onPressHandler !== "function"}
      android_ripple={{ color: "#dbeafe" }}
      hitSlop={6}
    >
      <Text style={styles.uploadPhotoText}>
        Upload a photo: {`${selectedCount} Selected`}
      </Text>
      <AntDesign name="pluscircle" size={20} color="#2563eb" />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  uploadPhotoBox: {
    marginTop: 10,
    backgroundColor: "#fff",
    minHeight: 48,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: "#d1d5db",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 12,
  },
  uploadPhotoBoxPressed: {
    backgroundColor: "#eff6ff",
    borderColor: "#93c5fd",
  },
  uploadPhotoText: {
    color: "#111827",
    fontWeight: "700",
    marginRight: 5,
  },
});

export default UploadPhotoBox;
